import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flag, Check } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '../../ui/popover';
import { PRIORITIES } from '../../../lib/constants';

const priorityConfig = Object.fromEntries(
  Object.entries(PRIORITIES).map(([k, v]) => [k, { ...v, color: v.textColor, bg: v.bgLight }])
);

const PriorityPicker = ({ value = 'p4', onChange, children, disabled = false }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const config = priorityConfig[value] || priorityConfig.p4;

  const defaultTrigger = (
    <button disabled={disabled} className={`flex items-center gap-1.5 px-2 py-1 rounded-md text-[13px] transition-colors ${
      disabled ? 'opacity-50 cursor-not-allowed' :
      value !== 'p4' ? `${config.bg} ${config.color}` : 'text-muted-foreground hover:bg-accent/60'
    }`}>
      <Flag className="w-3.5 h-3.5" />
      <span>{config.shortLabel}</span>
    </button>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {children || defaultTrigger}
      </PopoverTrigger>
      <PopoverContent className="w-44 p-1 bg-accent border-border max-md:!w-screen max-md:!max-w-none max-md:!rounded-b-none" align="start" sideOffset={4}>
        {Object.entries(priorityConfig).map(([key, cfg]) => (
          <button
            key={key}
            onClick={() => { onChange(key); setOpen(false); }}
            className={`w-full flex items-center justify-between px-2.5 py-1.5 rounded-md hover:bg-accent/60 text-sm ${value === key ? 'bg-accent/60' : ''}`}
          >
            <div className="flex items-center gap-2">
              <Flag className={`w-3.5 h-3.5 ${cfg.color}`} />
              <span className="text-foreground/80">{`${cfg.shortLabel} ${t(cfg.labelKey)}`}</span>
            </div>
            {value === key && <Check className="w-3.5 h-3.5 text-amber-700 dark:text-amber-400" />}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default PriorityPicker;
